export const stripHtml = (string) => {
	const div = document.createElement('div');
	div.innerHTML = string;

	return div.textContent || div.innerText || '';
};
